import { PublisherUserService } from '../../../../../../services/publisher-user.service';
import {
    Component,
    OnInit,
    ViewEncapsulation,
    ElementRef,
    Input
} from '@angular/core';
import { Helpers } from '../../../../../../helpers';
import { Router } from '@angular/router';
import { DatatableComponent } from '../../../datatable.component';
import { Paths } from '../../../../../../models/enums';
import { DataService } from '../../../../../../_services/data.service';

@Component({
    selector: 'app-publisherUser-list',
    templateUrl: './list-publisherUser.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ListPublisherUserComponent extends DatatableComponent
    implements OnInit {
    updateTrigger() {
        this.router.navigate(['/' + this.path + '/publisherUser/update', this.id], {
            queryParams: {
                publisherId: this.publisherId,
                publisherName: this.publisherName,
                returnUrl: this.routePath
            }
        });
    }
    deleteTrigger() {
        this.deleteRow(this.id);
    }
    buildDatatableParams() {
        this.selectorId = 'publisher-user-datatable';
        this.datatableUrl = '/publisherUsers/list?filterId=' + this.publisherId;
        this.columns = [
            {
                field: 'firstName',
                title: 'First Name',
                template: function(row) {
                    return row.firstName;
                }
            },
            {
                field: 'lastName',
                title: 'Last Name',
                template: function(row) {
                    return row.lastName;
                }
            },
            {
                field: 'email',
                title: 'Email',
                template: function(row) {
                    return row.email;
                }
            },
            {
                field: 'userGroup',
                title: 'User Group',
                template: function(row) {
                    // callback function support for column rendering
                    return row.userGroup.name;
                }
            },
            {
                field: 'Actions',
                width: 80,
                title: 'Actions',
                sortable: false,
                overflow: 'visible',
                textAlign: 'center',
                template: function(row) {
                    return (
                        '\
                    <button data-id="' +
                        row.id +
                        '" id="updatePublisherUser' +
                        row.id +
                        '" class="update-row m-datatable--on-layout-updated m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit "><i class="la la-edit"></i></button>\
                    <button data-id="' +
                        row.id +
                        '" id="deletePublisherUser' +
                        row.id +
                        '" class="delete-row m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete "><i class="la la-trash"></i></button>\
                '
                    );
                }
            }
        ];
    }

    datatable: any;
    path: string;
    @Input() publisherId: string;
    @Input() routePath: string;
    @Input() publisherName: string;

    constructor(
        private publisherUserService: PublisherUserService,
        protected el: ElementRef,
        private router: Router,
        private dataService: DataService
    ) {
        super(el);
        this.path = Helpers.getPath();
        if (!this.routePath) this.routePath = this.path + '/publisherUser/list';
        if (this.path == Paths.Publisher) {
            const profile = dataService.getUser();
            this.publisherId = profile.publisherId;
        }
    }

    ngOnInit() {
        this.buildDatatable();
    }

    onClickCreateUser() {
        this.router.navigate(['/' + this.path + '/publisherUser/create'], {
            queryParams: {
                publisherId: this.publisherId,
                publisherName: this.publisherName,
                returnUrl: this.routePath
            }
        });
    }

    deleteRow(publisherUserid: string) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                Helpers.setLoading(true);
                this.publisherUserService.delete(publisherUserid).subscribe(() => {
                    Helpers.setLoading(false);
                    this.swalService.successDelete();
                    this.datatable.load();
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/publisher-user/list-publisher-user/list-publisherUser.component.ts